import type { InputHTMLAttributes } from 'react';
import { input } from './Field.css';

interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'className'> {
  invalid?: boolean;
}

export function Input({ invalid, ...rest }: InputProps) {
  return <input className={input} data-invalid={invalid ? 'true' : undefined} {...rest} />;
}
